module.exports = __webpack_public_path__ + "ba0cd681afec460feeba153ceaa76b44.svg";